import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "7.75",
      y: "7.75",
      width: "16.5",
      height: "16.5",
      rx: "1.25",
      stroke: "#868686",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }